const CITIES = '/cities';
const CHECKOUT = '/checkout';
const MENU = 'menu';

export const hideFooterPaths = [CITIES];
export const hideAnnouncementBarPaths = [CITIES, CHECKOUT];
export const hideNavPaths = [CHECKOUT];
export const menuNavPaths = [MENU];
